import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Grid, FormControlLabel, Checkbox } from '@mui/material';
import { Autocomplete, TextField } from '@totalsoft/rocket-ui';

const ResponsibleChangeOfferListFilters = ({ t, loadStates, filters, onChangeFilterValue, loadDealer, userInfoDealer }) => {
  const handleTextFilterChanged = name => event => {
    onChangeFilterValue(name, event);
  };

  const handleCheckBoxFilterChanged = name => event => {
    const value = event.target.checked;
    onChangeFilterValue(name, value);
  };
  const handleLookupValueChanged = name => value => onChangeFilterValue(name, value);

  return (
    <Grid item container xs={12} spacing={2}>
      <Grid item xs={12} sm={6} lg={1}>
        <TextField
          id={'offerResponsibleChange_filters_offerNumber'}
          fullWidth
          label={t('OfferList.OfferNumber')}
          value={filters.offerNumber}
          onChange={handleTextFilterChanged('offerNumber')}
          debounceBy={500}
        />
      </Grid>
      <Grid item xs={12} sm={6} lg={3}>
        <TextField
          id={'offerResponsibleChange_filters_client'}
          fullWidth
          label={t('OfferResponsibleChange.Client')}
          value={filters.clientName}
          onChange={handleTextFilterChanged('clientName')}
          debounceBy={500}
        />
      </Grid>
      <Grid item xs={12} sm={6} lg={2}>
        <Autocomplete
          id={'offerResponsibleChange_filters_status'}
          fullWidth
          value={filters.offerState}
          onChange={handleLookupValueChanged('offerState')}
          label={t('OfferResponsibleChange.Status')}
          valueKey='stateId'
          labelKey='name'
          isClearable
          isSearchable
          loadOptions={loadStates}
        />
      </Grid>
      <Grid item xs={12} md={6} lg={4}>
          <Autocomplete
            id={'offerResponsibleChange_filters_dealer'}
            fullWidth
            cache={false}
            value={filters.dealer}
            onChange={handleLookupValueChanged('dealer')}
            label={t("OfferList.Dealer")}
            valueKey='dealerId'
            labelKey='name'
            loadOptions={loadDealer}
            isClearable
            isSearchable
            disabled={userInfoDealer != null}
          />
        </Grid>
      <Grid item xs={12} sm={6} lg={2}>
        <FormControlLabel
          control={
            <Checkbox
              id={'offerResponsibleChange_filters_isAssigned'}
              checked={filters.isAssigned}
              onChange={handleCheckBoxFilterChanged('isAssigned')}
              color='primary'
              name='isAssigned'
            />
          }
          label={t('OfferResponsibleChange.IsAssigned')}
        />
      </Grid>
    </Grid>
  );
};

ResponsibleChangeOfferListFilters.propTypes = {
  t: PropTypes.func.isRequired,
  loadStates: PropTypes.func.isRequired,
  filters: PropTypes.object.isRequired,
  onChangeFilterValue: PropTypes.func.isRequired,
  loadDealer: PropTypes.func.isRequired, 
  userInfoDealer: PropTypes.object
};

export default withTranslation()(ResponsibleChangeOfferListFilters);
